export default __webpack_public_path__ + "static/media/clio-small.dfda46b3.jpg";